const toggleClass = (el, className) => {
	if (el.classList.contains(className)) {
		el.classList.remove(className);
	}
	else {
		el.classList.add(className);
	}
};

export default () => {
	const gridEl = document.querySelector('.js-grid');
	window.addEventListener('keydown', (e) => {
		e = e || window.event;
		if ((e.which === 71 || e.keyCode === 71) && e.ctrlKey) {
			toggleClass(gridEl, 'is-active');
		}
	});
};
